/**
 * testimonial-carousel
 */

import $ from 'jquery';

// Module dependencies
import 'protons';

// Module styles
import '../../01-atoms/testimonial/_testimonial.scss';
import './_testimonial-carousel.scss';

// Module template
import './_testimonial-carousel.twig';

import swipe from 'jquery-touchswipe/jquery.touchSwipe';

export const name = 'testimonial-carousel';

export const defaults = {
  dummyClass: 'js-testimonial-carousel-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context, { testimonialCarousel = {} }) {
  // Find our component within the DOM
  const $testimonialCarousel = $('.testimonial-carousel', $context);
  // Bail if component does not exist
  if (!$testimonialCarousel.length) {
    return;
  }
  // Merge defaults with incoming settings
  const settings = {
    ...defaults,
    ...testimonialCarousel,
  };
  // An example of what could be done with this component
  $testimonialCarousel.addClass(settings.dummyClass);
}

let resizeTimer;
const RESIZE_DEBOUNCE_INTERVAL = 300;
const responsive = window.matchMedia('(max-width: 767px)');
const carouselOpts = {
  pause: 'hover',
};
const carousel$ = $("[class^='testimonial-carousel']").find('.carousel');

function resizeRecalc(elCarousel) {
  if (resizeTimer) {
    clearTimeout(resizeTimer);
  }
  resizeTimer = setTimeout(() => {
    if (responsive.matches) {
      elCarousel.carousel(0);
      elCarousel.carousel('pause');
    } else if (!responsive.matches) {
      elCarousel.carousel('cycle');
    }
  }, RESIZE_DEBOUNCE_INTERVAL);
}

$(document).ready(() => {
  if (carousel$.length && $.fn.carousel) {
    carousel$.each(function () {
      const elCarousel = $(this);

      if (elCarousel.data('interval') === undefined) {
        $.extend(carouselOpts, { interval: 7000 });
      } else {
        $.extend(carouselOpts, { interval: elCarousel.data('interval') });
      }

      elCarousel.carousel(carouselOpts);

      const children = elCarousel.find('.carousel-item');
      children.each(function () {
        const child = $(this);
        child.removeClass('active');
      });
      children.first().addClass('active');

      if (swipe) {
        elCarousel.swipe({
          swipe(event, direction) {
            if (direction === 'left' && !responsive.matches) {
              $(this).carousel('next');
            }

            if (direction === 'right' && !responsive.matches) {
              $(this).carousel('prev');
            }
          },
          allowPageScroll: 'vertical',
        });
      }

      elCarousel.on('slide.bs.carousel', () => {
        if (responsive.matches) {
          // elCarousel.carousel('pause');
        }
      });
      elCarousel.on('slid.bs.carousel', () => {
        if (responsive.matches) {
          // elCarousel.carousel('pause');
        }
      });

      $(window).resize(resizeRecalc(elCarousel));
      window.addEventListener('orientationchange', resizeRecalc, false);
    });
  }
});

export default enable;
